"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _events = _interopRequireDefault(require("./events"));
var _MultiTab = _interopRequireDefault(require("./MultiTab"));
require("./index.less");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var api = {
  /**
   * open new tab on route fullPath
   * @param config
   */
  open: function open(config) {
    _events.default.$emit('open', config);
  },
  rename: function rename(key, name) {
    _events.default.$emit('rename', {
      key: key,
      name: name
    });
  },
  /**
   * close current page
   */
  closeCurrentPage: function closeCurrentPage() {
    this.close();
  },
  /**
   * close route fullPath tab
   * @param config
   */
  close: function close(config) {
    _events.default.$emit('close', config);
  }
};
_MultiTab.default.install = function (Vue) {
  if (Vue.prototype.$multiTab) {
    return;
  }
  api.instance = _events.default;
  Vue.prototype.$multiTab = api;
  Vue.component('multi-tab', _MultiTab.default);
};
var _default = exports.default = _MultiTab.default;